/* eslint-disable react/self-closing-comp */
import React from 'react'
import { Navigate } from 'react-router-dom'
import { useQuery } from '@apollo/client'

// material
import { styled } from '@mui/material/styles'
import { Container } from '@mui/material'
import { complaintByCognitoId } from '../graphql/queries'

// Menu
import Menu from '../components/Menu'
import ClientMenuLeft from './common/ClientMenuLeft'
// components
import Page from '../components/Page'

import ClientDashboard from '../components/client/ClientDashboard'
import DisplayLoading from '../components/common/DisplayLoading'
import DisplayError from '../components/common/DisplayError'

import { ROLES } from '../redux/auth/auth.actions'
// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}))

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 1000,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}))

// ----------------------------------------------------------------------

export default function ClientDashboardPage() {
  const userId = localStorage.getItem('userId')

  const {
    data: complaintData,
    error: complaintError,
    loading: complaintLoading,
  } = useQuery(complaintByCognitoId, {
    variables: { cognitoId: userId },
    fetchPolicy: 'network-only',
  })

  const userProfile = localStorage.getItem('userProfile')
  const hasRole = userProfile && userProfile === ROLES.ADMIN

  if (hasRole) {
    return <Navigate to="/401-admin" />
  }

  return (
    <RootStyle title=" Mes plaintes | Gestion des plaintes">
      <Menu />
      <ClientMenuLeft />

      <Container>
        <ContentStyle>
          <DisplayLoading
            loadingMessage={complaintLoading}
            iconName="circle notched"
          />

          <DisplayError errorMessage={complaintError} />
          {complaintData && <ClientDashboard complaintData={complaintData} />}
        </ContentStyle>
      </Container>
    </RootStyle>
  )
}
